module.exports = __webpack_public_path__ + "media/src/assets/Images/BanqueHeritage-1aa4974a9094368294614bcad7ee4461.svg";